import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import { useSelector } from 'react-redux';
import { findOEM } from '@utils/editor';
import selectors from '@state/selectors';
import * as S from './styles';
import C from '@assets/themes/colors';
import { Context } from '@routes/private/Editor/Context';
import { getCommonValue } from 'utils/multiEditing';
import ComboBox from '@components/ComboBox';
import { findFontByNameOrId, getFonts } from 'utils/fonts';
import { IBrandConfigFont } from '@state/dsconfig/types';
import _ from 'lodash';

const MultiEditingFontFamilyAttribute:React.FC<IProps> = (props) => {
  const [value, setValue]= useState("");
  const [isOpen, setIsOpen] = useState(false);
  const context = useContext(Context);
  const [fontsList, setFontsList] = useState<IBrandConfigFont[]>([]);
  const dsConfig = useSelector(selectors.dsConfig.getDSConfig);
  const oem = findOEM(context.entityInformation);

  useEffect(() => {
    const commonValue = getCommonValue(props.name,props.elementType,props.selectDescribeFieldId,context.data,context.selectDescribe?.taggedFields);
    const font = findFontByNameOrId(dsConfig.brands, "id", commonValue);
    if (font) setValue(font.name);
  }, [context.data, props.fieldId]);

  const handleChangeFontFamily = (id: string, fontFamily: string) => {
    const font = findFontByNameOrId(dsConfig.brands, "name", fontFamily);
    if (value !== fontFamily && font) {
      context.onCommandChange(props.name,font.id,undefined,undefined,undefined,true);
      setValue(font.name);
    } 
  }

  const handleFocusInput = () => {
    context.onMultiEditingFocus([props.selectDescribeFieldId]);
    const commonValue = getCommonValue(props.name,props.elementType,props.selectDescribeFieldId,context.data,context.selectDescribe?.taggedFields);
    const font = findFontByNameOrId(dsConfig.brands, "id", commonValue);
    if(commonValue !== "" && font) {
      setValue(font.name);
    }
  }

  useEffect(() => {
    if (isOpen) {
      getFontsAync();
    } else {
      setFontsList([]);
    }
  }, [isOpen]);

  const getFontsAync = async () => {
    const fontsList = getFonts(dsConfig, oem, true);
    setFontsList(fontsList);
  }

  return (
    <S.FontFamilyContainer
      onClick={handleFocusInput}
    >
      <ComboBox
        id={`${props.selectDescribeFieldId}`}
        placeholder={value}
        options={_.flatten(fontsList.map(font => {return font.name}))}
        required={false}
        disabled={false}
        position={"bottom"}
        chooseOption={handleChangeFontFamily}
        value={value}
        light={true}
        containerStyle={{
          marginTop: `15px`,
        }}
        style={{
          fontSize: `14px`,
          color: `${C.BLUE}`,
          padding: `0px 6px`,
        }}
        optionContainerStyle={{
          maxHeight: `500px`,
        }}
        optionStyle={{
          fontSize: `14px`,
          color: `${C.BLUE}`,
          padding: `6px`,
        }}
        setIsOpen={setIsOpen}
      />
    </S.FontFamilyContainer>
  );
}

export default MultiEditingFontFamilyAttribute;